/** Label for the `hiddenBy` enum: ADMIN, BOT, or PM shown as PROPERTY. */
export const hiddenByLabel = (hiddenBy?: string | null) =>
  hiddenBy === 'PM' ? 'PROPERTY' : hiddenBy || 'ADMIN';
